import { userUpdateApi } from "../../api/user/userUpdateApi"

type PayloadShape = Parameters<typeof userUpdateApi>[0]

export async function userUpdateService(payload: PayloadShape, token: string) {
	return await userUpdateApi(payload, token)
}
